{
  "version": 1,
  "asset_id": "858cb81a-5e71-470a-bdf3-9d5a669a8dd7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/858cb81a-5e71-470a-bdf3-9d5a669a8dd7/hiatal-type-3-second-en-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/858cb81a-5e71-470a-bdf3-9d5a669a8dd7/hiatal-type-3-second-en-800.jpg",
  "original_filename": "hiatal-type-3-second-en-800.jpg",
  "size": 148772,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T23:53:31Z"
}
